/**
 * Marks the window in which the store initializers run, so the API layer can
 * tell a request the merchant asked for from one the app fired on its own.
 *
 * A background failure is still logged (console.error -> Datadog, Hotjar) and
 * still retried by `StoreInitializer`, but it must not raise a toast: the
 * merchant did not ask for it, cannot act on it, and on a brand-new account it
 * is the very first thing the portal shows them (TWISM-19940).
 *
 * A counter rather than a boolean: `execute` can be re-entered through a
 * `requires` dependency, and the window must survive the inner call closing.
 */
let depth = 0;

export const isBackgroundRequest = (): boolean => depth > 0;

export const runAsBackgroundRequest = async <T>(
  run: () => Promise<T>
): Promise<T> => {
  depth++;
  try {
    return await run();
  } finally {
    depth--;
  }
};

/** Test-only: the counter is module state and leaks between specs otherwise. */
export const resetBackgroundRequestDepth = (): void => {
  depth = 0;
};
